import React, { useState, useMemo } from 'react';
import { Select, Tag } from 'antd';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Copy from 'src/component/Copy';
import InnerHeader from 'src/component/InnerHeader';
import NoxTable from 'src/component/Table';
import { SearchBy } from 'src/component/Table/enums/searchby.enum';
import { formatDate } from 'src/helpers/millisecondsToFormattedDate';
import Loader from 'src/component/Loader/Loader';
import { useGetBoxes } from 'src/reactQuery/box/useGetBoxes';
import { useDeleteBox } from 'src/reactQuery/box/useDeleteBox';
import { BoxResponseData, BoxTableData } from 'src/reactQuery/box/interfaces/box.interface';

const { Option } = Select;

const useStyles = makeStyles({
  garbage: {
    cursor: 'pointer',
    left: '8px',
    position: 'absolute',
    top: '0px'
  },
  passwordWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '14px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  },
  select: {
    marginTop: '16px'
  }
});

const Boxes = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[] | undefined>([]);
  const { data, isLoading, refetch } = useGetBoxes();
  const { mutate } = useDeleteBox({ onSuccess: refetch });
  const classes = useStyles();
  const history = useHistory();

  const filteredData: BoxTableData[] | undefined = useMemo(() => {
    if (!data) {
      return;
    }
    const filteredNotifications: BoxTableData[] | undefined = data?.data.map(
      // @ts-ignore
      (box: BoxResponseData) => {
        const { _id, type, user, createdAt, updatedAt } = box;
        return {
          _id,
          createdAt,
          key: _id,
          type,
          updatedAt,
          user
        };
      }
    );

    return filteredNotifications;
  }, [data?.data]);

  const columns = [
    {
      dataIndex: '_id',
      key: 'id',
      render: (_id: string) => {
        return <Copy text={_id} />;
      },
      sorter: (a: BoxTableData, b: BoxTableData) => a._id.localeCompare(b._id),
      title: 'ID'
    },
    {
      dataIndex: 'user',
      key: 'user',
      render: (user: string) => {
        return <Copy text={user} />;
      },
      sorter: (a: BoxTableData, b: BoxTableData) => a.user.localeCompare(b.user),
      title: 'User'
    },
    {
      dataIndex: 'type',
      key: 'type',
      render: (type: string) => {
        return <Copy text={type} />;
      },
      sorter: (a: BoxTableData, b: BoxTableData) => a.type.toString().localeCompare(b.type),
      title: 'Type'
    },
    {
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: Date) => {
        return <Copy text={formatDate(createdAt)?.[0] || ''} />;
      },
      sorter: (a: BoxTableData, b: BoxTableData) =>
        a.createdAt.toString().localeCompare(b.createdAt.toString()),
      title: 'Created At'
    },
    {
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (updatedAt: Date) => {
        return <Copy text={formatDate(updatedAt)?.[0] || ''} />;
      },
      sorter: (a: BoxTableData, b: BoxTableData) =>
        a.updatedAt.toString().localeCompare(b.updatedAt.toString()),
      title: 'Updated At'
    },
    {
      key: 'edit',
      render: (category: BoxTableData) => <Tag onClick={() => openDetail(category)}>Edit</Tag>
    }
  ];

  const onNotificationDelete = async () => {
    selectedRowKeys?.forEach((item: number) => {
      mutate(item.toString());
    });
  };

  const openDetail = (item: BoxTableData) => {
    history.push({
      pathname: `/box/${item._id}`
    });
  };

  const actions = [];

  if (selectedRowKeys?.length) {
    actions.unshift({
      onClick: onNotificationDelete,
      title: 'Delete',
      type: 'primary'
    });
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      style={{
        backgroundColor: 'white',
        height: 'calc(100vh - 155px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={data?.paging?.total} title="Notifications" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={filteredData}
        loading={isLoading}
        searchBy={SearchBy.TITLE}
        // @ts-ignore
        selectedRowKeys={selectedRowKeys}
        // @ts-ignore
        setSelectedRowKeys={setSelectedRowKeys}
        totalPages={data?.paging?.total}
      />
    </div>
  );
};

export default Boxes;
